'use strict';

/* globals define, config, ajaxify, $ */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/survey/survey-results', [
	config.relative_path + '/plugins/nodebb-plugin-surveys/static/vendor/chartjs/Chart.min.js',
], function (Chart) {
	var	SurveyResults = {};

	SurveyResults.init = function () {
		for (var i = 0; i < ajaxify.data.results.length; i++) {
			createChartForQuestion(ajaxify.data.results[i]);
		}
	};

	function createChartForQuestion(question) {
		var ctx = $('#' + question.id);

		var labels = [];
		var data = [];

		for (var i = 0; i < question.answers.length; i++) {
			labels.push(question.answers[i].weight);
			data.push(question.answers[i].votes);
		}

		new Chart(ctx, {
			type: 'bar',
			data: {
				labels: labels,
				datasets: [{
					data: data,
					borderWidth: 1,
					backgroundColor: [
						'rgba(255, 99, 132, 0.2)',
						'rgba(54, 162, 235, 0.2)',
						'rgba(255, 206, 86, 0.2)',
						'rgba(75, 192, 192, 0.2)',
						'rgba(153, 102, 255, 0.2)',
						'rgba(255, 159, 64, 0.2)',
						'rgba(223, 3, 252, 0.2)',
						'rgba(20, 181, 71, 0.2)',
						'rgba(181, 63, 20, 0.2)',
						'rgba(140, 81, 4, 0.2)',
					],
					borderColor: [
						'rgba(255, 99, 132, 1)',
						'rgba(54, 162, 235, 1)',
						'rgba(255, 206, 86, 1)',
						'rgba(75, 192, 192, 1)',
						'rgba(153, 102, 255, 1)',
						'rgba(255, 159, 64, 1)',
						'rgba(223, 3, 252, 1)',
						'rgba(20, 181, 71, 1)',
						'rgba(181, 63, 20, 1)',
						'rgba(140, 81, 4, 1)',
					],
				}],
			},
			options: {
				legend: {
					display: false,
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							stepSize: 1,
						},
					}],
				},
			},
		});
	}

	return SurveyResults;
});
